<template>
    <div class="overflow-hidden rounded-card border border-panel-border bg-white">
        <div class="bg-panel px-4 py-1.5">
            <h4 class="!mb-0 text-xs !font-bold">
                {{ trans('workorder.msd.title') }}
                <em v-if="!readonly" class="text-danger">*</em>
            </h4>
        </div>

        <div class="px-4 py-3">
            <p class="!mb-2.5 text-[14px]">{{ trans('workorder.msd.question') }}</p>
            <yes-no-selector
                :disabled="readonly"
                :model-value="msd.called"
                :no-label="trans('workorder.msd.no')"
                :yes-label="trans('workorder.msd.yes')"
                test-id="msd-called"
                @update:model-value="onCalledUpdate"
            />

            <div v-if="msd.called === true" class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <label class="mb-1.5 block text-[13px] text-muted">{{ trans('workorder.msd.name.label') }}</label>
                    <input
                        :class="fieldClasses"
                        :disabled="readonly"
                        :placeholder="trans('workorder.msd.name.placeholder')"
                        :value="msd.name ?? ''"
                        data-testid="msd-name"
                        type="text"
                        @input="updateField('name', $event.target.value)"
                    />
                </div>
                <div>
                    <label class="mb-1.5 block text-[13px] text-muted">{{ trans('workorder.msd.called_at.label') }}</label>
                    <div :class="[fieldClasses, 'flex items-center']">
                        <time-field
                            :disabled="readonly"
                            :model-value="msd.called_at ?? null"
                            data-testid="msd-called-at"
                            @update:model-value="updateField('called_at', $event)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import YesNoSelector from '@/Components/YesNoSelector.vue';
import { TimeField } from '@/Components/ui/time-field';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const msd = computed(() => props.modelValue ?? {});

const fieldClasses = computed(() => [
    'h-9.5 w-full rounded-lg border border-gray-light bg-white px-4 text-sm placeholder:text-muted',
    props.readonly ? 'cursor-not-allowed opacity-60' : '',
]);

const updateField = (key, val) => {
    emit('update:modelValue', { ...msd.value, [key]: val });
};

const onCalledUpdate = (val) => {
    if (val === true) {
        emit('update:modelValue', { ...msd.value, called: true });
        return;
    }
    emit('update:modelValue', { called: false, name: null, called_at: null });
};
</script>
